import { Loader, Stack, Text } from '@repletoryreach/sdk-ui';
import { BrandLogo } from '../../components/BrandLogo';
import { BrandWordmark } from '../../components/BrandWordmark';
import { useT } from '../../i18n/I18nProvider';

/**
 * What both auth guards show while `GET /v1/me` decides whether there is a
 * session. It used to be one unstyled line of text on a white page, which on a
 * cold boot over a slow link is indistinguishable from a broken build.
 */
export function BootSplash() {
  const t = useT();
  return (
    <div className="rr-page-loading">
      <div className="rr-page-loading__inner">
        <BrandLogo size={44} style={{ color: 'var(--rr-color-primary)' }} />
        <Text role="subtitle" fw={800}><BrandWordmark /></Text>
        <Loader size="sm" aria-label={t('common.loading')} />
        <Text role="bodySmall" c="var(--rr-color-text-muted)">{t('shell.loading.title')}</Text>
      </div>
    </div>
  );
}
